var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getBaseUrl } from '../../config';
import { onApiError } from './errors';
const axiosInstance = axios.create();
function toFormData(data) {
    if (!data)
        return '';
    if (typeof data === 'string')
        return data;
    const formDataArray = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const appendFormData = (key, value) => {
        if (Array.isArray(value)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value.forEach((item) => {
                appendFormData(`${key}[]`, item); // recursively handle nested arrays
            });
        }
        else if (typeof value === 'object') {
            Object.keys(value).forEach((subKey) => {
                appendFormData(`${key}[${subKey}]`, value[subKey]); // recursively handle nested objects
            });
        }
        else {
            formDataArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    Object.keys(data).forEach((key) => {
        appendFormData(key, data[key]);
    });
    return formDataArray.join('&');
}
function axiosCall(configs, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
resolve, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
reject
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    return __awaiter(this, void 0, void 0, function* () {
        // Default for the legacy endpoints; a request may override it via configs.baseURL.
        axiosInstance.defaults.baseURL = `${getBaseUrl()}/booking`;
        return axiosInstance
            .request(configs)
            .then((res) => {
            resolve(res.data);
        })
            .catch((err) => {
            reject(err);
        });
    });
}
function getConfigs({ baseURL, contentType = 'application/x-www-form-urlencoded', method = 'post', headers, url, }) {
    return {
        // Per-request override of the instance default set in axiosCall. Left
        // undefined, axios falls back to that default.
        baseURL,
        headers: Object.assign(Object.assign({}, headers), { 'content-type': contentType }),
        method,
        url,
    };
}
function getValuable(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => !((typeof v === 'string' && !v.length) ||
        v === null ||
        typeof v === 'undefined')));
}
export const apiCall = (Model) => (method, url, params, options) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const configs = getConfigs(Object.assign({ method, url }, options));
        const contentType = (options === null || options === void 0 ? void 0 : options.contentType) || 'application/x-www-form-urlencoded';
        const data = params ? getValuable(params) : undefined;
        if (method === 'get' || method === 'delete') {
            configs.params = data;
        }
        else {
            configs.data =
                contentType === 'application/x-www-form-urlencoded'
                    ? toFormData(Object.assign({}, data))
                    : data;
        }
        axiosCall(configs, (response) => {
            const obj = new Model(response);
            resolve(obj);
        }, reject);
    }).catch((err) => {
        throw onApiError(url, params, err);
    });
});
